import { render, staticRenderFns } from "./HaciendasMediterraneo.vue?vue&type=template&id=01c0fa2a&scoped=true&"
import script from "./HaciendasMediterraneo.vue?vue&type=script&lang=js&"
export * from "./HaciendasMediterraneo.vue?vue&type=script&lang=js&"
import style0 from "./HaciendasMediterraneo.vue?vue&type=style&index=0&id=01c0fa2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c0fa2a",
  null
  
)

export default component.exports